export default __webpack_public_path__ + "static/radeef-1b265149c640c141c2d2ab5adaaa72fa.png";